import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import SelectSupplierModal from "@/components/supplier/SelectSupplierModal";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import { SUPPLIER_STAGE } from "@/constants";
import { useModalBehavior } from "@/hooks/behaviors";
import { SupplierUserSimpleListItem } from "@/types/apis";
import { Col, Form, Input, InputNumber, Row, Select, DatePicker } from "antd";
import type { PurchaseContractFormValues } from "../type";
import styles from "@/asserts/styles/formSection.module.less";

const CURRENCY_OPTIONS = [
  { label: "人民币 (CNY)", value: "CNY" },
  { label: "美元 (USD)", value: "USD" },
  { label: "港币 (HKD)", value: "HKD" },
];

export function BasicContractFormFields() {
  const form = Form.useFormInstance<PurchaseContractFormValues>();

  const {
    open: supplierModalOpen,
    openModal: openSupplierModal,
    closeModal: closeSupplierModal,
  } = useModalBehavior();

  const onSelectSupplierModalClose = (
    pickedSupplier?: SupplierUserSimpleListItem,
  ) => {
    if (pickedSupplier) {
      form.setFieldsValue({
        supplierCode: pickedSupplier.supplierCode,
        supplierNameZh: pickedSupplier.supplierName,
        supplierNameEn: pickedSupplier.supplierUsName,
      });
    }
    closeSupplierModal();
  };

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="合同基础信息" />

      <div className={styles.sectionBody}>
        {/* 供应商信息 */}
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="supplierCode"
              label="供应商编号"
              rules={[{ required: true, message: "请选择供应商编号" }]}
            >
              <Input
                placeholder="请选择供应商"
                readOnly
                onClick={openSupplierModal}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="supplierNameZh"
              label="供应商名称（中文）"
              rules={[{ required: true, message: "请输入供应商名称" }]}
            >
              <Input
                placeholder="请选择供应商"
                readOnly
                onClick={openSupplierModal}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="supplierNameEn"
              label="供应商名称（英文）"
            >
              <Input placeholder="自动带出" readOnly />
            </Form.Item>
          </Col>
        </Row>

        {/* 合同基础信息 */}
        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractName"
              label="合同名称"
              rules={[{ required: true, message: "请输入合同名称" }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractCode"
              label="合同编号"
              rules={[{ required: true, message: "请输入合同编号" }]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="currency"
              label="币种"
              rules={[{ required: true, message: "请选择币种" }]}
            >
              <Select options={CURRENCY_OPTIONS} placeholder="请选择" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractAmount"
              label="合同总金额"
              rules={[{ required: true, message: "请输入合同金额" }]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="请输入"
                min={0}
                precision={2}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item<PurchaseContractFormValues>
              name="contractPeriod"
              label="合同期限"
              rules={[{ required: true, message: "请选择合同期限" }]}
            >
              <DatePicker.RangePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>

        {/* 合同内容 */}
        <Row gutter={49}>
          <Col span={24}>
            <Form.Item<PurchaseContractFormValues>
              name="contractContent"
              label="合同内容"
            >
              <Input.TextArea rows={4} placeholder="请输入" />
            </Form.Item>
          </Col>
        </Row>

        {/* 附件 */}
        <Row gutter={49}>
          <Col span={24}>
            <MaterialFileFormFields<PurchaseContractFormValues>
              fieldName="contractFiles"
              label="合同文件"
              required={false}
            />
          </Col>

          <Col span={24}>
            <MaterialFileFormFields<PurchaseContractFormValues>
              fieldName="relatedFiles"
              label="相关文件"
              required={false}
            />
          </Col>
        </Row>
      </div>

      <SelectSupplierModal
        open={supplierModalOpen}
        onClose={onSelectSupplierModalClose}
        fixedSupplierStage={SUPPLIER_STAGE.ONBOARDING}
      />
    </div>
  );
}
